import React, { useEffect, useState } from 'react';
import clientService from '../../../services/clientService';
import { Gauge, Search, User, Calendar } from 'lucide-react';

const ProjectsProgress = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');

  useEffect(() => { load(); }, []);

  const load = async () => {
    try {
      setLoading(true);
      const res = await clientService.getProjects({ per_page: 100, search });
      setProjects(res.data || []);
    } catch (e) {
      console.error(e);
    } finally { setLoading(false); }
  };

  const updateProgress = async (id, progress) => {
    try {
      await clientService.updateProjectProgress(id, progress);
      setProjects(prev => prev.map(p => p.id === id ? { ...p, progress, status: progress === 100 ? 'completed' : (progress > 0 ? 'in_progress' : p.status) } : p));
    } catch (e) {
      alert('Error updating progress');
    }
  };

  return (
    <div>
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-primary mb-2">Project Progress</h1>
        <p className="text-gray-600">Update progress quickly for all ongoing projects</p>
      </div>

      <div className="bg-white rounded-xl shadow-md p-6 mb-6">
        <div className="flex gap-3 items-center">
          <div className="relative flex-1">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 w-5 h-5" />
            <input value={search} onChange={(e)=>setSearch(e.target.value)} onKeyDown={(e)=> e.key==='Enter' && load()} placeholder="Search projects..." className="w-full pl-10 pr-4 py-2 border-2 border-gray-200 rounded-lg focus:border-primary"/>
          </div>
          <button onClick={load} className="px-4 py-2 bg-gray-200 hover:bg-gray-300 rounded-lg">Apply</button>
        </div>
      </div>

      <div className="bg-white rounded-xl shadow-md overflow-hidden">
        <div className="px-6 py-4 bg-gradient-to-r from-primary to-primary-700">
          <h2 className="text-xl font-bold text-white">Projects ({projects.length})</h2>
        </div>
        {loading ? (<div className="p-10 text-center">Loading...</div>) : (
          <div className="divide-y">
            {projects.length === 0 ? (
              <div className="p-8 text-center text-gray-500">No projects found</div>
            ) : projects.map(p => (
              <div key={p.id} className="p-6 flex items-center justify-between gap-6">
                <div className="flex-1 min-w-0">
                  <div className="font-semibold text-gray-900 truncate">{p.project_name}</div>
                  <div className="text-xs text-gray-500 flex items-center gap-3 mt-1">
                    <span className="flex items-center gap-1"><User className="w-3 h-3"/>{p.client?.company_name || '—'}</span>
                    <span className="flex items-center gap-1"><Calendar className="w-3 h-3"/>{p.start_date || '-'} → {p.end_date || '-'}</span>
                    <span className="capitalize">{(p.project_type||'').replace('_',' ')}</span>
                  </div>
                </div>
                <div className="w-64">
                  <label className="text-xs text-gray-600 flex items-center gap-2 mb-1"><Gauge className="w-4 h-4"/> {p.progress || 0}%</label>
                  <input type="range" min="0" max="100" value={p.progress || 0} onChange={(e)=>updateProgress(p.id, parseInt(e.target.value,10))} className="w-full"/>
                  <div className="w-full bg-gray-200 rounded-full h-2 mt-2">
                    <div className="h-2 bg-primary rounded-full" style={{ width: `${p.progress||0}%` }} />
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ProjectsProgress;
